import { Children, cloneElement } from "react";

type FlexProps = React.HTMLAttributes<HTMLDivElement> & {
  // biome-ignore lint/suspicious/noExplicitAny: Too complex to type
  children: React.ReactElement<any>[];
  className?: string;
  count: number;
  direction?: "row" | "column";
  offset?: number;
  style?: React.CSSProperties;
  wrap?: boolean;
};

function toPercent(num: number): string {
  return `${num}%`;
}

export default function Flex({
  children,
  className,
  count,
  direction,
  offset,
  style,
  wrap,
  ...otherProps
}: FlexProps): React.ReactElement {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: direction,
        flexWrap: wrap ? "wrap" : "nowrap",
        ...style,
      }}
      {...otherProps}
    >
      {Children.map(children, (child, index) => {
        const marginInlineStart =
          offset && index === 0 ? toPercent((102 * offset) / count) : null;

        return cloneElement(child, {
          ...child.props,
          style: {
            width: toPercent(100 / (count + 1)),
            flexShrink: 0,
            flexGrow: 0,
            overflow: "hidden",
            marginLeft: marginInlineStart,
            marginInlineStart: marginInlineStart,
            marginInlineEnd: 0,
          },
        });
      })}
    </div>
  );
}
